module.exports = __webpack_public_path__ + "img/bg-01.4d0da6de.jpg";